import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { take } from 'rxjs';
import { Objection, ObjectionType } from '../../../core/objection/objection';
import { ObjectionService } from '../../../core/objection/objection.service';
import { SessionTemplate } from '../../../core/session-template/session-template';
import { SessionTemplateService } from '../../../core/session-template/session.template.service';

@Component({
  selector: 'app-edit-objection-list-session-template',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzFormModule,
    NzRadioModule,
    NzSelectModule,
    NzSegmentedModule,
    NzPopconfirmModule,
    NzInputNumberModule,
  ],
  templateUrl: './edit-objection-list-session-template.component.html',
  styleUrl: './edit-objection-list-session-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditObjectionListSessionTemplateComponent {
  @Input() sessionTemplate?: SessionTemplate;

  @Input() isEmotionalObjection = false;

  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  selectedObjectionId?: string;
  onSelectedObjectionIdChange(id: string) {
    // this.selectedObjectionId = id;
    if (id) {
      if (this.isEmotionalObjection) {
        this.sessionTemplate?.unsafeSubData?.emotionalObjectionIdList?.push(id);
      } else {
        this.sessionTemplate?.unsafeSubData?.factObjectionIdList?.push(id);
      }

      this.sessionTemplateService.update$(this.sessionTemplate!).pipe(take(1)).subscribe();
    }
  }

  allObjectionList = toSignal(this.objectionService.itemList$(), { initialValue: [] });
  sessionTemplateList = toSignal(this.sessionTemplateService.itemList$(), { initialValue: [] });

  getObjection = (id?: string) => computed(() => this.allObjectionList().find((item) => item.id === id));

  emotionalObjectionSessionTemplateList = computed<Objection[]>(() => {
    const itemList = this.allObjectionList();
    this.sessionTemplateList();

    const result: Objection[] = [];

    this.sessionTemplate?.unsafeSubData?.emotionalObjectionIdList?.forEach((id) => {
      const item = itemList.find((item) => item.id === id);
      if (item) {
        result.push(item);
      }
    });

    return result;
  });

  factObjectionSessionTemplateList = computed<Objection[]>(() => {
    const itemList = this.allObjectionList();

    this.sessionTemplateList();

    const result: Objection[] = [];

    this.sessionTemplate?.unsafeSubData?.factObjectionIdList?.forEach((id) => {
      const item = itemList.find((item) => item.id === id);
      if (item) {
        result.push(item);
      }
    });

    return result;
  });

  emotionalObjectionList = computed<Objection[]>(() => {
    return this.allObjectionList()?.filter((item) => item.type === ObjectionType.emotional) ?? [];
  });

  factObjectionList = computed<Objection[]>(() => {
    return this.allObjectionList()?.filter((item) => item.type === ObjectionType.fact) ?? [];
  });

  constructor(
    private sessionTemplateService: SessionTemplateService,
    private objectionService: ObjectionService
  ) {}

  onDeleteClick(objection: Objection) {
    let objectionIndex = this.sessionTemplate!.unsafeSubData?.emotionalObjectionIdList?.findIndex(
      (id) => id === objection.id
    );

    console.log(objectionIndex);

    if (objectionIndex !== undefined && objectionIndex >= 0) {
      this.sessionTemplate!.unsafeSubData!.emotionalObjectionIdList?.splice(objectionIndex, 1);
      this.sessionTemplateService.update$(this.sessionTemplate!).pipe(take(1)).subscribe();
    } else {
      objectionIndex = this.sessionTemplate!.unsafeSubData?.factObjectionIdList?.findIndex((id) => id === objection.id);

      if (objectionIndex !== undefined && objectionIndex >= 0) {
        this.sessionTemplate!.unsafeSubData!.factObjectionIdList?.splice(objectionIndex, 1);
        this.sessionTemplateService.update$(this.sessionTemplate!).pipe(take(1)).subscribe();
      }
    }
  }

  onIsVisibleChange(isVisible: boolean) {
    this.isVisibleChange.emit(isVisible);
  }

  onCancelClick() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
